import APIDocsPage from "./APIDocsPage";
import APIEditor from "./APIEditor";

export { APIEditor };
export default APIDocsPage;
